var _circle, _path, _path2, _rect, _rect2, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteRankingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1869 25.353H18.234V26.4999H18.2341V27.647H17.087V26.5001H13.1871V27.647H12.04V26.4999H13.1869V25.353ZM14.5634 28.7944H13.4163V30.1706H12.04V31.3177H18.2342V30.1706H14.5634V28.7944ZM17.0867 27.6471H14.5631V28.7942H17.0867V27.6471Z",
    fill: "#180F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.04 25.353H39.1695V26.9589H39.169V28.3351H37.7928V29.2531H39.169V30.4004H39.1695V32.0063H35.04V30.4004H37.5631V29.4824H36.1869V28.1059H37.5631V26.9589H35.04V25.353Z",
    fill: "#180F24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.04,
    y: 19.353,
    width: 3.44122,
    height: 1.14708,
    fill: "#180F24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.876,
    y: 20.2705,
    width: 1.6059,
    height: 5.27654,
    fill: "#180F24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.04,
    y: 25.5474,
    width: 4.81771,
    height: 1.37649,
    fill: "#180F24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7849 14.5H19.7849H31.6803H33.6803V16.5V21.1528H41.0814H43.0814V23.1528V33.2471V35.2471H41.0814H10H8V33.2471V23.1528V21.1528H10H17.7849V16.5V14.5ZM19.7849 21.1528V23.1528H17.7849H12V24.5H10V25.1528V31.2471V32.5H12V33.2471H39V32.5H41.0814V31.2471V25.1528V24.5H39V23.1528H33.6803H31.6803V21.1528V18.5H30V16.5H29.6803H22V18.5H19.7849V21.1528Z",
    fill: "#180F24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRankingIcon);
export default __webpack_public_path__ + "static/media/white-ranking-icon.3f030a390421d4aa7003203508a3157b.svg";
export { ForwardRef as ReactComponent };